import { render } from "./Navbar.vue?vue&type=template&id=94b6bfcc&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=94b6bfcc&scoped=true&lang=css"

import exportComponent from "D:\\_\\node\\work\\muso-ninjas\\node_modules\\.pnpm\\vue-loader@17.0.1_u4ryg6e3aznhweo4gilim5qufe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94b6bfcc"]])

export default __exports__